import { useState as v, useRef as S, useEffect as f } from "react";
import { SelectCard as E } from "../../UI/Blocks/SelectCard/SelectCard.js";
import { jsx as F } from "../../_virtual/jsx-runtime.js";
function p(t, o) {
  return !o.relatedTarget || o.relatedTarget !== t && !t.contains(o.relatedTarget);
}
function x(t, o, l) {
  const [a, u] = v(!1), c = S(l);
  return f(() => {
    c.current = l;
  }, [l]), f(() => {
    const e = document.querySelector(`label[for="${t}"`);
    !e || (e.addEventListener("focusin", (r) => {
      p(e, r) && u(!0);
    }), e.addEventListener("focusout", (r) => {
      p(e, r) ? (u(!1), o(t, c.current, {
        shouldTouch: !0,
        shouldValidate: !1
      })) : r.stopPropagation();
    }));
  }, []), {
    isFocused: a
  };
}
function y({
  fetchResults: t,
  displayLabel: o,
  onSelect: l,
  setFieldValue: a,
  setFieldFocus: u,
  inputName: c,
  focusAfterSelect: e,
  className: r,
  sourceValue: i,
  triggerFieldValidation: T
}) {
  const [d, m] = v([]), h = S(void 0), {
    isFocused: g
  } = x(c, a, i);
  f(() => {
    m([]);
    const n = Date.now();
    h.current = n, i && t().then((s) => {
      h.current === n && m(s);
    }).catch((s) => {
      console.error(s);
    });
  }, [i || null]);
  const b = (n) => {
    var s;
    e ? u(e) : (s = document.activeElement) == null || s.blur(), setTimeout(() => {
      l(n), T(c);
    }, 0);
  };
  return /* @__PURE__ */ F(E, {
    className: r,
    visible: g && d.length > 0,
    onSelect: b,
    options: d.map((n) => ({
      label: o(n),
      value: n
    }))
  });
}
export {
  y as AutoCompleteDialog
};
//# sourceMappingURL=AutoCompleteDialog.js.map
